/**
 * Advanced-block image carousel.
 *
 * Replaces the Bootstrap 4 carousel this block used to run on. The caption and the
 * slide counter used to be a second Bootstrap carousel driven off `slide.bs.carousel`;
 * they are now plain text swapped on Glide's `run` event, so there is no second
 * instance to keep in sync.
 */
import Glide from '@glidejs/glide';

document.querySelectorAll('.js-advnc-image-carousel').forEach((el) => {
    const slides = Array.from(el.querySelectorAll('.glide__slide'));

    if (slides.length < 2) {
        return;
    }

    const glide = new Glide(el, {
        type: 'carousel',
        perView: 1,
        gap: 0,
        animationDuration: 500,
    });

    const caption = el.querySelector('.js-advnc-image-carousel__caption');
    const nominator = el.querySelector('.js-advnc-image-carousel__nominator');

    const sync = () => {
        const slide = slides[glide.index];

        if (!slide) {
            return;
        }

        if (caption) {
            caption.textContent = slide.getAttribute('data-caption') || '';
        }

        if (nominator) {
            const value = glide.index + 1;
            nominator.textContent = value < 10 ? '0' + value : String(value);
        }
    };

    glide.on(['mount.after', 'run'], sync);
    glide.mount();
});
